import { useState, useId } from "react";
import { Plus, Minus } from "lucide-react";

function FaqItem({ q, a, open, onToggle }) {
  const id = useId();
  return (
    <div className="border-b border-gold/20">
      <h3>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          aria-controls={`${id}-panel`}
          id={`${id}-btn`}
          className="w-full flex items-center justify-between gap-6 py-6 text-left group"
          data-testid="faq-question"
        >
          <span className="font-serif text-xl sm:text-2xl text-ink group-hover:text-rose transition-colors">
            {q}
          </span>
          <span className="shrink-0 text-rose" aria-hidden="true">
            {open ? <Minus size={22} strokeWidth={1.5} /> : <Plus size={22} strokeWidth={1.5} />}
          </span>
        </button>
      </h3>
      <div
        id={`${id}-panel`}
        role="region"
        aria-labelledby={`${id}-btn`}
        hidden={!open}
        className="pb-6 pr-10 text-ink/70 leading-relaxed max-w-2xl"
      >
        {a}
      </div>
    </div>
  );
}

export default function FaqAccordion({ items, singleOpen = false }) {
  const [openSet, setOpenSet] = useState(() => new Set([0]));

  const toggle = (i) => {
    setOpenSet((prev) => {
      const next = new Set(singleOpen ? [] : prev);
      if (prev.has(i)) next.delete(i);
      else next.add(i);
      return next;
    });
  };

  return (
    <div className="border-t border-gold/20" data-testid="faq-accordion">
      {items.map((it, i) => (
        <FaqItem
          key={it.q}
          q={it.q}
          a={it.a}
          open={openSet.has(i)}
          onToggle={() => toggle(i)}
        />
      ))}
    </div>
  );
}
